module.exports = __webpack_public_path__ + "media/img/apple-icon-144x144-e8864cfd626e7cd5b1b670a1c70d38c7.png";